<template>
  <div
    :class="{
      'electron-my-course': isElectron,
      'h5-my-course': isH5,
      'my-course': !isH5,
    }"
  >
    <div class="courses-wrap">
      <!-- 课程分类 -->
      <div class="course-filter-bar">
        <ul class="tabs-wrap">
          <li
            @click="changeTab(item.value)"
            v-for="item in tabList"
            :key="item.value"
            :class="{
              'is-active': activeTab === item.value,
            }"
          >
            <span> {{ item.name }}</span>
            <span v-if="item.value === 'all' && total">&nbsp;{{ total }}</span>
          </li>
        </ul>
        <CourseSearchInput
          v-model="keyword"
          :loading="searchSubmitting"
          :search-disabled="!canSubmitSearch"
          @search="handleSearch"
          @clear="handleClearSearch"
        />
      </div>
      <!-- 课程列表 -->
      <ul
        ref="courseListWrap"
        @scroll="handleScroll"
        v-if="courseList.length"
        v-loading="resultLoading"
        class="course-list-wrap"
      >
        <li
          class="my-course-crad"
          :class="{ 'expired-card': item.expired }"
          @click="showDetail(item)"
          v-for="(item, index) in courseList"
          :key="item.course_id + index"
        >
          <p v-if="item.expired" class="expired">已过期</p>
          <div>
            <div class="cover">
              <img :src="processImageUrl(item.cover_url, 600)" alt="" />
              <!-- 直播中 -->
              <div v-if="item.live_state" class="layer-wrap">
                <div class="living-tag">
                  <img
                    src="../../../assets/images/living-white.gif"
                    alt=""
                  />进入直播
                </div>
              </div>
              <button
                v-if="item.canEvaluate"
                @click.stop="goToEvaluate(item)"
                class="evaluate-btn"
              >
                去评价
              </button>
            </div>
            <div class="course-info">
              <p class="name">
                {{ item.course_name }}
              </p>
              <div>
                <div class="lesson-num">
                  <p>
                    课时数：<span>{{ item.lesson_count }}课时</span>
                  </p>
                </div>
                <p class="time">课程有效期： {{ dealValidityType(item) }}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <el-empty
        v-else
        v-loading="resultLoading"
        description="暂无内容"
        :image="require('@/assets/img/live-list/empty.png')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { isH5, processImageUrl } from "@saas/components";
import moment from "moment";
import { getCourseList } from "@saas/service-api/src/learning-center";
import { getUnEvaluatedList } from "@saas/service-api/src/evaluate/index";
import { getCoursesState } from "@saas/service-api/src/course";
import CourseSearchInput from "./components/CourseSearchInput.vue";
import {
  buildCourseListParams,
  canSubmitCourseSearch,
  createDelayedLoadingController,
  normalizeCourseKeyword,
} from "./course-list-search";
export default {
  components: {
    CourseSearchInput,
  },
  data: function () {
    return {
      moment,
      courseList: [],
      keyword: "",
      activeKeyword: "",
      page_no: 1,
      page_size: 12,
      noMore: false, //没有更多
      loading: false, //加载数据中
      resultLoading: false,
      searchSubmitting: false,
      resultLoadingController: null,
      courseListRequestId: 0,
      isElectron: window.isElectron,
      isH5: isH5(),
      tabList: [
        {
          name: "全部课程",
          value: "all",
        },
        {
          name: "付费课程",
          value: "pay",
        },
        {
          name: "免费课程",
          value: "free",
        },
      ],
      activeTab: "all",
      total: 0,
    };
  },
  created() {
    this.resultLoadingController = createDelayedLoadingController({
      setLoading: (value) => {
        this.resultLoading = value;
      },
    });
    this.apiGetCourseList();
  },
  mounted() {},
  beforeDestroy() {
    if (this.resultLoadingController) {
      this.resultLoadingController.cancel();
    }
  },
  computed: {
    canSubmitSearch() {
      return canSubmitCourseSearch({
        keyword: this.keyword,
        activeKeyword: this.activeKeyword,
      });
    },
  },
  methods: {
    processImageUrl,
    dealValidityType(item) {
      if (item.validity_type === 1) {
        return `至 ${moment(item.end_validity * 1000).format(
          "YYYY年MM月DD日"
        )}`;
      } else if (item.validity_type === 2) {
        if (isH5) {
          return `至${moment(item.end_validity * 1000).format(
            "YYYY年MM月DD日"
          )}`;
        } else {
          return `至${moment(item.end_validity * 1000).format(
            "YYYY年MM月DD日 HH:mm:ss"
          )}`;
        }
      } else {
        return "永久有效";
      }
    },
    changeTab(value) {
      if (this.activeTab === value) return false;
      this.activeTab = value;
      this.page_no = 1;
      this.noMore = false;
      if (this.$refs?.courseListWrap) {
        this.$refs.courseListWrap.scrollTop = 0;
      }
      this.apiGetCourseList();
    },
    handleSearch() {
      if (this.searchSubmitting || !this.canSubmitSearch) return;
      this.activeKeyword = normalizeCourseKeyword(this.keyword);
      this.page_no = 1;
      this.noMore = false;
      if (this.$refs?.courseListWrap) {
        this.$refs.courseListWrap.scrollTop = 0;
      }
      this.searchSubmitting = true;
      this.apiGetCourseList().finally(() => {
        this.searchSubmitting = false;
      });
    },
    handleClearSearch() {
      if (this.searchSubmitting) return;
      if (!this.activeKeyword) return;
      this.activeKeyword = "";
      this.page_no = 1;
      this.noMore = false;
      if (this.$refs?.courseListWrap) {
        this.$refs.courseListWrap.scrollTop = 0;
      }
      this.searchSubmitting = true;
      this.apiGetCourseList().finally(() => {
        this.searchSubmitting = false;
      });
    },
    // 监听列表滚动
    handleScroll(event) {
      if (this.noMore || this.loading) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.loading = true;
        this.page_no++;
        this.apiGetCourseList();
      }
    },
    apiGetCourseList() {
      const requestId = ++this.courseListRequestId;
      const shouldShowResultLoading = this.page_no === 1;
      this.loading = true;
      if (shouldShowResultLoading) {
        this.resultLoadingController.start();
      }
      let params = buildCourseListParams({
        page_no: this.page_no,
        page_size: this.page_size,
        keyword: this.activeKeyword,
      });
      if (this.activeTab === "pay") {
        params.fee_type = 2;
      } else if (this.activeTab === "free") {
        params.fee_type = 1;
      }
      return getCourseList(params)
        .then((res) => {
          if (requestId !== this.courseListRequestId) return;
          if (res.code === 1) {
            let arr = res.data?.list || [];
            let courseIds = []; //课程ids
            let now = new Date().getTime();
            arr = arr.map((item) => {
              courseIds.push(item.course_id);
              let expired = item.end_validity * 1000 < now;
              let { is_comment, learned_lesson_count, lesson_count } = item;
              return {
                ...item,
                expired,
                canEvaluate:
                  !is_comment &&
                  !expired &&
                  learned_lesson_count &&
                  lesson_count,
                live_state: 0,
              };
            });
            if (params.page_no === 1) {
              this.courseList = arr;
            } else {
              this.courseList = this.courseList.concat(arr);
            }
            if (this.activeTab === "all") {
              this.total = res.data.total || 0;
            }
            if (this.courseList.length === res.data.total) {
              this.noMore = true;
            } else {
              this.noMore = false;
            }
            if (courseIds?.length) {
              // 获取课程状态
              this.apiGetCourseState(courseIds, requestId);
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          if (requestId !== this.courseListRequestId) return;
          this.$message.error(err?.message || "加载失败");
        })
        .finally(() => {
          if (requestId !== this.courseListRequestId) return;
          this.loading = false;
          if (shouldShowResultLoading) {
            this.resultLoadingController.stop();
          }
        });
    },
    apiGetCourseState(courseIds, requestId) {
      getCoursesState({
        course_ids: courseIds.join(","),
      }).then((res) => {
        if (requestId !== this.courseListRequestId) return;
        if (res.code === 1 && res.data?.length) {
          let haveStatusIds = res.data.map((item) => item.course_id);
          this.courseList.forEach((course) => {
            if (haveStatusIds.includes(course.course_id)) {
              let { live_state } = res.data.find(
                (element) => element.course_id === course.course_id
              );
              course.live_state = live_state;
            }
          });
        }
      });
    },
    handleElScrollFn(event) {
      if (this.loading || this.noMore) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.loading = true;
        this.page_no++;
        this.apiGetCourseList();
      }
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.loading = true;
          this.page_no++;
          this.apiGetCourseList();
        } else {
          window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
        }
      }
    },

    showDetail(item) {
      let { course_id, expired } = item;
      if (expired) {
        this.$showToast("课程已过期，无法进行观看");
      } else {
        this.$router.push({
          name: "myCourseDetail",
          params: { id: course_id },
        });
      }
    },
    handleExpired() {
      this.$showToast("课程已过期，无法进行观看");
    },
    goToEvaluate(item) {
      // 1. 课程课时数为 0，给错误提示“课程中暂无课时，不能评价”
      // 2. 若已学习课时数为 0，给错误提示“至少学完一个课时才可以评价”
      // 3. 已评价||已过期 不展示评价入口
      getUnEvaluatedList({
        page_no: 1,
        page_size: 1,
        course_id: item.course_id,
      }).then((res) => {
        if (res.code === 1) {
          if (res.data.list[0]) {
            const courseInfo = res.data.list[0] || {};
            if (courseInfo.lesson_count < 1) {
              this.$message.error("课程中暂无课时，不能评价");
            } else if (courseInfo.learned_lesson_count < 1) {
              this.$message.error("至少学完一个课时才可以评价");
            } else {
              this.$router.push("/comment/" + item.course_id);
            }
          } else {
            this.$message.error("已评价");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-course {
  // min-height: calc(100vh - 110px);
  .courses-wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--card-bg);
    border-radius: 24px;
    min-height: 752px;
    height: calc(
      100vh - #{$nav-bar-height} - #{$nav-footer-height} - 30px - 30px
    );
    margin-bottom: 30px;
    .course-filter-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 64px;
      padding: 0 18px 0 14px;
      border-bottom: 1px solid var(--user-btn-border);
      gap: 16px;
      --course-search-width: 260px;
    }
    .tabs-wrap {
      display: flex;
      align-items: center;
      height: 54px;
      cursor: pointer;
      flex: 1;
      li {
        font-weight: 600;
        font-size: 16px;
        color: var(--text-primary);
        line-height: 22px;
        margin: 0 20px;
      }
      .is-active {
        position: relative;
        &::after {
          position: absolute;
          display: block;
          content: "";
          left: 50%;
          transform: translateX(-50%);
          bottom: -15px;
          width: 30px;
          height: 4px;
          background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
          border-radius: 3px;
        }
      }
    }
  }
  .course-list-wrap {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    overflow-y: auto;
    padding: 16px 16px;
    &:hover::-webkit-scrollbar-thumb {
      background: #c9cdd4;
    }
  }
  .course-list-wrap::-webkit-scrollbar {
    width: 4px;
  }
  .course-list-wrap::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
  }
  .my-course-crad {
    margin: 0 12px 16px 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
    overflow: hidden;
    &.expired-card > div {
      opacity: 0.5;
    }
  }
  .my-course-crad {
    &:hover {
      transition: all 0.3s ease;
      transform: translateY(-5px);
      box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
      // .cover img {
      //   transform: scale(1.2) rotate(0.02deg);
      // }
    }
    transition: all 0.3s ease;
    width: 330px;
    background: var(--card-bg);
    border-radius: 24px;
    border: 1px solid var(--user-btn-border);
    cursor: pointer;
    position: relative;
    height: max-content;
    & > div {
      display: flex;
      flex-direction: column;
      height: 322px;
    }
    .expired {
      position: absolute;
      right: 7px;
      top: 156px;
      width: 50px;
      height: 22px;
      background: var(--input-bg);
      border-radius: 4px;
      font-weight: 500;
      font-size: 12px;
      color: var(--text-secondary);
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
    }
    .cover {
      width: 100%;
      height: 184px;
      // border-radius: 16px 16px 0 0;
      // margin-bottom: 14px;
      overflow: hidden;
      position: relative;
      .evaluate-btn {
        position: absolute;
        right: 7px;
        bottom: 7px;
        width: 50px;
        height: 22px;
        background: var(--card-bg);
        border-radius: 4px;
        border: 1px solid #00c89d;
        font-weight: 500;
        font-size: 12px;
        color: #00c89d;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .cover img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      // transition: 0.3s ease-in-out;
      // will-change: transform;
      // transform: scale(1) rotate(0.02deg);
    }
    .layer-wrap {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(13, 20, 0, 0.4);
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      // border-radius: 16px 16px 0 0;
      .living-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 106px;
        height: 30px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 14px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 22px;
        img {
          width: 19px;
          height: 19px;
          margin-right: 2px;
        }
      }
    }
    .course-info {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 14px 16px 16px;
      .name {
        font-weight: 500;
        font-size: 18px;
        color: var(--text-primary);
        line-height: 28px;
        word-break: break-all;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-bottom: 6px;
      }
      .lesson-num {
        margin-bottom: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .lesson-num,
      .time {
        font-weight: 400;
        font-size: 14px;
        color: var(--text-secondary);
        line-height: 20px;
      }
    }
  }
  .el-empty {
    height: 400px;
    background: var(--card-bg);
    border-radius: 24px;
  }
}

// 客户端
.my-course.electron-my-course {
  min-height: auto;
  height: auto;
  .courses-wrap {
    background: transparent;
    min-height: auto;
    height: calc(100vh - #{$top-bar-height} - 10px);
    .course-filter-bar {
      min-height: 58px;
      padding-right: 14px;
      gap: 12px;
      --course-search-width: 220px;
      --course-search-height: 34px;
      --course-search-inner-height: 32px;
      --course-search-btn-height: 30px;
    }
  }
  .tabs-wrap {
    li {
      font-weight: 400;
      font-size: 14px;
      color: var(--text-primary);
      line-height: 20px;
    }
    .is-active {
      font-weight: 600;
      font-size: 14px;
      color: var(--text-primary);
      line-height: 20px;
    }
  }
  .course-list-wrap {
    padding: 16px 0;
  }
  .my-course-crad {
    margin: 0 15px 15px 0;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .my-course-crad {
    width: 260px;
    border-radius: 18px;
    & > div {
      height: 263px;
      padding: 10px;
    }
    .expired {
      top: 115px;
      right: 15px;
    }
    .cover {
      width: 240px;
      height: 135px;
      border-radius: 16px;
      margin-bottom: 12px;
    }
    .course-info {
      padding: 0;
      .name {
        font-size: 14px;
        line-height: 20px;
      }
      .lesson-num {
        margin-bottom: 6px;
      }
      .lesson-num,
      .time {
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
  .el-empty {
    background: transparent;
  }
}

// h5
.h5-my-course {
  padding-top: 1.39rem;
  .course-list-wrap {
    display: block;
  }
  .my-course-crad {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-items: center;
    width: 9.36rem;
    height: 2.61rem;
    background: #ffffff;
    border-radius: 0.32rem;
    margin: 0 auto 0.32rem;
    padding: 0 0.27rem;
    .cover {
      width: 3.2rem;
      height: 2.08rem;
      border-radius: 0.16rem;
      margin-right: 0.27rem;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .course-info {
      height: 2.08rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      width: 0;
      .name {
        font-weight: 500;
        font-size: 0.37rem;
        color: #0d1400;
        line-height: 0.53rem;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-break: anywhere;
      }
      .lesson-num,
      .time {
        font-weight: 400;
        font-size: 0.32rem;
        color: #747573;
        line-height: 0.45rem;
      }
      .lesson-num {
        margin-bottom: 0.11rem;
      }
    }
  }
}
</style>
